import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {DualListboxComponent} from "./dual-list-box.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		TranslateModule
	],
	declarations: [
		DualListboxComponent
	],
	exports: [
		DualListboxComponent
	]
})
export class DualListboxModule {} // end class export class DualListboxModule